// extracted by mini-css-extract-plugin
export default {"skeletonBlockContainer":"FilterDropdownV2__skeletonBlockContainer___KlWXd","skeletonCard":"FilterDropdownV2__skeletonCard___mhBKL"};